const CHUNK_LOAD_ERROR_PATTERN = /ChunkLoadError|Loading (?:CSS )?chunk .* failed|(?:Failed to fetch|error loading) dynamically imported module|Importing a module script failed/i;

export function isChunkLoadError(error: unknown) {
    return error instanceof Error && CHUNK_LOAD_ERROR_PATTERN.test(`${error.name} ${error.message}`);
}
